<template>
  <div style="height: 85vh; width: 84vw; background-color: white; " class="pt-4">
    <v-row class="pt-1; pb-1">
      <v-col cols="8" style="padding-right: 0px">
        <div style="height: 82vh; width: 100%">
          <l-map ref="refMap" class="small-map" :zoom="zoom" :center="center" :maxZoom="22" @update:zoom="zoomUpdated"
            @update:center="centerUpdated" @update:bounds="boundsUpdated">
            <custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution" :maxZoom="22"
              :maxNativeZoom="18" />

            <l-feature-group ref="featureGroup"></l-feature-group>
            <l-marker ref="mapRef" :lat-lng="markerLatLng" @ready="map_ready">
              <l-popup>
                <b>
                  {{ site }}
                </b>
                <br />
                {{ address }}
                <br />
                {{ postalCode }} , {{ city }}
                <br />
                <hr />
                {{ markerLatLng[0] }},{{ markerLatLng[1] }}
              </l-popup>
            </l-marker>

          </l-map>
        </div>
      </v-col>
      <v-col cols="4" style="height: 82vh; display: flex; flex-wrap: wrap; align-content: space-between;">
        <div>
          <v-card-text>
            <div class="title2">
              {{ $t('_detourez_site_') }}
            </div>
            <p class="texte">
              {{ $t("_cliquez_sur_le_bouton_") }}
              <img style="height: 20px" :src="getIconSource('polygon')" :alt="$t('button.polygon_alt')" />
              {{ $t("_et_tracez_le_contour_") }}
              {{ $t("_en_cas_derreur_") }}
              <img style="height: 20px" :src="getIconSource('bin')" :alt="$t('button.bin_alt')" />
              {{ $t("_puis_cliquer_sur_save") }}
              {{ $t("_et_recommencer_") }}
            </p>
          </v-card-text>
          <v-card-text>
            <div class="texte">
              {{ $t("_importer_ue_image_de_mon_site_") }}
            </div>
            <div>
              <input id="input" accept="image/jpg, image/png, image/jpeg" type="file" @change="getFile($event)">
              <br>
              <label v-if="this.badFileFormat" style="color: red;">{{ $t('_choisir_une_image_format_') }}</label>
            </div>
            <v-btn v-if="fileURL !== null" @click="supprimerImage()"> Supprimer l'image</v-btn>
          </v-card-text>
        </div>
        <v-btn :disabled="nbrPoly === 0" @click="openModal()" style="margin-left: auto ;margin-right: 15px;">
          {{ $t('_valider_') }}
        </v-btn>
        <PopUpAddImage v-if="modal" @close="closeModalImage($event)" :center="center" :imageURL="fileURL"
          :markerLatLng="markerLatLng"></PopUpAddImage>
        <PopUpAnalyse v-if="modalState" :centre="getCenter()" :image="imageExiste" :install_id="installation_id" @close="$emit('finPopUp')"></PopUpAnalyse>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { LMap, LFeatureGroup } from 'vue2-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar';

import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'
import 'leaflet-distortableimage'

import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

import api from "@/api/api";
import backend from '@/api/backend';
import PopUpAnalyse from './PopUpAnalyse';
import PopUpAddImage from './PopUpAddImage.vue';

//Presque comme la tileLayer cloassique de esri mais ajouter différemment pour ajouter un zoom artificiel
const CustomTileLayer = {
  name: 'CustomTileLayer',
  props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
  mounted() {
    const tileLayer = L.tileLayer(this.url, {
      attribution: this.attribution,
      maxZoom: this.maxZoom,
      maxNativeZoom: this.maxNativeZoom,
      noWrap: true,
      tms: false,
    });

    tileLayer.addTo(this.$parent.mapObject);
  },
  render() {
    return null;
  }
};

export default {
  components: { LMap, CustomTileLayer, LFeatureGroup, PopUpAnalyse, PopUpAddImage },

  async mounted() {
    //Si le site existe dans la base d'helioicity, recuperer les infos la bas
    try {
      var res = (await api.get_layout_model_global_info(this.installation_id))

      this.identification[0].value = res.data.prm
      this.identification[1].value = res.data.installed_power
      this.markerLatLng = [res.data.latitude, res.data.longitude]
      this.center = [res.data.latitude, res.data.longitude]
      this.address = res.data.address
      this.postalCode = res.data.postal_code
      this.city = res.data.city
      //this.country = res.data.country
      this.site = res.data.name
    } catch   //Sinon c'est que c'est un site créée dans l'appli, recuperer les info chez nous
    {
      const res = (await backend.get_install_form(this.installation_id)).data
      const description = res.description
      this.identification[0].value = description.prm
      this.identification[1].value = description.pInstallee
      this.markerLatLng = [parseFloat(description.markerLatLng0), parseFloat(description.markerLatLng1)]
      this.center = this.markerLatLng
      this.address = description.adresse
      this.postalCode = description.codePostal
      this.city = description.ville
      this.site = description.nom
    }

    //Ajoute la possibilité de dessiner sur la carte
    this.$nextTick(async () => {
      const map = this.$refs.refMap.mapObject;
      const featureGroup = this.$refs.featureGroup.mapObject;

      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: featureGroup,
          edit: true,
          remove: true,
        },
        draw: {
          circle: false,
          marker: false,
          polyline: false,
          circlemarker: false,
          rectangle: false,
        },
      });
      // Ajouter le contrôle de dessin à la carte
      map.addControl(this.drawControl);

      map.on('draw:created', (e) => this.onCreated(e));
      map.on('draw:deleted', (e) => this.onDeleted(e));

      //afficher l'iage s'il y en a une
      try {

        let corners = (await backend.get_mask_install(this.installation_id)).data
        this.fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)
        const map = this.$refs.refMap.mapObject

        const options = {
          corners: corners,
          suppressToolbar: true,
          editable: false,
          actions: [],
          mode: ''
        }

        this.overlay = L.distortableImageOverlay(this.fileURL, options).addTo(map)
        this.imageExiste = true
      }
      catch (error) {
        console.error("Pas d'image à recuperer")
      }

    });
  },

  beforeDestroy() {
    //Libere la memoire
    URL.revokeObjectURL(this.imageUrl);
  },

  data() {
    return {
      installation_id: this.$route.params.id,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 17,
      markerLatLng: [0, 0],
      center: [48.866667, 2.333333],
      address: "8 rue de micheline",
      site: "Mon site",
      postalCode: "75000",

      city: "Paris",
      mapRef: null,
      bounds: null,
      fileURL: null,
      modal: false,
      imageExiste: false,
      overlay: null,
      tileProviders:
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
        visible: true,
        name: "satelliteESRI",
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      },


      //Installation details
      identification: [
        {
          id: 'prm',
          name: 'n° PRM',
          value: "",
          info: ""
        },
        {
          id: 'pc',
          name: '_puissance_crete_(kwc)_',
          value: "",
          info: "(vs. XXX fournis)"
        }
      ],
      modalState: false,
      nbrPoly: 0,
      badFileFormat: false
    };
  },

  methods: {
    refresHeader() {
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getMenu() {
      return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.target_menu
    },
    map_ready() {
      this.$r
    },

    //A l'ajout d'une image, verifie le dype de fichier et ouvre la popup de dpositionnement de l'image
    getFile(event) {
      let file = event.target.files[0]
      const allowedType = ["image/jpg", "image/jpeg", "image/png"]
      if (!allowedType.includes(file.type)) {
        this.badFileFormat = true
        event.target.value = ""
      }
      else {
        this.fileURL = URL.createObjectURL(event.target.files[0])
        this.modal = true
        this.badFileFormat = false
      }
    },

    //Ajoute l'image sur la carte et en database
    async closeModalImage(reponse) {
      const map = this.$refs.refMap.mapObject
      if (this.imageExiste) {
        map.removeLayer(this.overlay)
      }

      const options = {
        corners: reponse,
        suppressToolbar: true,
        editable: false,
        actions: [],
        mode: ''
      }

      this.overlay = L.distortableImageOverlay(this.fileURL, options).addTo(map)
      const blobImage = await (await fetch(this.fileURL)).blob();
      // const blob = await response.blob();
      // return blob;
      if (this.imageExiste) {
        await backend.put_mask_install(this.installation_id, reponse)
        backend.put_mask_file_install(this.installation_id, blobImage)

      }
      else {
        await backend.post_mask_install(this.installation_id, reponse)
        backend.post_mask_file_install(this.installation_id, blobImage)

      }
      this.imageExiste = true
      this.modal = false
    },

    // Ajouter le nouveau dessin au FeatureGroup (et donc sur la carte)
    onCreated(event) {
      const layer = event.layer;
      this.$refs.featureGroup.mapObject.addLayer(layer);
      this.nbrPoly = this.$refs.featureGroup.mapObject.getLayers().length;
    },

    //Supprime un ou plusieurs elements de la carte. Declangé quand on click sur "save"
    onDeleted(event) {
      const deletedLayers = event.layers;

      if (deletedLayers && deletedLayers.getLayers().length > 0) {
        deletedLayers.eachLayer((layer) => {
          this.$refs.featureGroup.mapObject.removeLayer(layer);
          this.nbrPoly = this.$refs.featureGroup.mapObject.getLayers().length;
        });
      } else {
        console.error("Aucune couche supprimée trouvée.");
      }
    },

    //our la popup de paramettrage de l'analyse d'image et envoi du contour au back
    async openModal() {
      var edges = [];
      this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        var latLngs = polygone.getLatLngs();
        if (latLngs && latLngs.length > 0) {
          // Aplatir les coordonnées
          const flatLatLngs = latLngs[0].map(coord => [coord.lat, coord.lng]);
          flatLatLngs.push(flatLatLngs[0]);
          edges.push(flatLatLngs);
        }
      });
      this.modalState = true;
      backend.put_edges_install(this.installation_id, edges);
    },

    getIconSource(iconType) {
      if (iconType === 'polygon') {
        return '/img/polygone-button.PNG'; // Define the icon for the polygon button
      } else if (iconType === 'bin') {
        return '/img/bin-button.PNG'; // Define the icon for the bin button
      }
      return ''; // Default/fallback icon si besoin
    },

    //Supprime l'image de la carte et du back
    supprimerImage() {
      this.$refs.refMap.mapObject.removeLayer(this.overlay)
      this.overlay = null
      this.fileURL = null
      backend.delete_mask_install(this.installation_id)
      this.imageExiste = false
    },

    getCenter(){
      let layerList= this.$refs.featureGroup.mapObject._layers
      return layerList[Object.keys(layerList)[0]].getBounds().getCenter();
    }
  }
};
</script>

<style scoped>
.small-map {
  height: 100%;
  width: 100%;
  aspect-ratio: 1 / 1;
  z-index: 0;
}

.title2 {
  font-size: 3rem;
  height: fit-content;
  line-height: 3rem;
}

.texte {
  margin-top: 10%;
  font-size: 20px;
}
</style>
